import { render, staticRenderFns } from "./NoticesTable.vue?vue&type=template&id=03414c80&scoped=true&"
import script from "./NoticesTable.vue?vue&type=script&lang=ts&"
export * from "./NoticesTable.vue?vue&type=script&lang=ts&"
import style0 from "./NoticesTable.vue?vue&type=style&index=0&id=03414c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03414c80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
